{
  "tenant": {
    "title": "Organization work schedule",
    "description": "Define the organization's standard workday. It is the basis for capacity and workload calculations.",
    "hoursPerDay": "Hours per day",
    "workingDays": "Working days per week",
    "isDefaultBadge": "Default",
    "save": "Save schedule",
    "saving": "Saving...",
    "loadError": "Could not load the organization work schedule."
  },
  "segments": {
    "add": "Add segment",
    "remove": "Remove segment"
  },
  "overrides": {
    "title": "Custom schedules",
    "description": "Members with a workday different from the organization's.",
    "empty": "No custom schedules",
    "emptyDescription": "All members use the organization work schedule.",
    "hoursPerDay": "{{count}} h/day",
    "memberLabel": "Member {{userId}}",
    "updatedAt": "Updated {{time}}",
    "searchPlaceholder": "Search by member...",
    "edit": "Edit schedule",
    "loadError": "Could not load custom schedules."
  },
  "member": {
    "title": "Work schedule",
    "description": "Define the hours per day for {{name}}.",
    "hoursPerDay": "Hours per day",
    "inheritsDefault": "Inherits the organization schedule ({{hours}} h/day).",
    "save": "Save",
    "saving": "Saving...",
    "delete": "Delete schedule",
    "deleteConfirm": "Delete custom schedule",
    "deleteConfirmDesc": "The member will revert to the organization work schedule. This action cannot be undone.",
    "cancel": "Cancel",
    "loadError": "Could not load the member work schedule.",
    "savedToast": "Schedule updated",
    "savedToastDesc": "{{name}}'s schedule has been updated.",
    "deletedToast": "Schedule deleted",
    "deletedToastDesc": "{{name}} will revert to the organization work schedule."
  },
  "errors": {
    "daysRequired": "Working days is required",
    "daysInt": "Working days must be a whole number",
    "daysRange": "Working days must be between 1 and 7",
    "segmentsEmpty": "Add at least one schedule segment",
    "segmentTimeRequired": "Select a start and end time for this segment",
    "segmentEndBeforeStart": "The end time must be after the start time",
    "segmentsOverlap": "Segments must be in order and cannot overlap"
  },
  "apiErrors": {
    "invalidHours": "The hours-per-day value is invalid",
    "invalidDays": "The working-days value is invalid",
    "memberNotFound": "The member was not found",
    "tenantSaveDefault": "Could not save the organization work schedule",
    "memberSaveDefault": "Could not save the member work schedule",
    "memberDeleteDefault": "Could not delete the member work schedule"
  }
}
